var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { observer } from 'mobx-react';
import { action, computed, observable, runInAction } from 'mobx';
import { FieldType, Filter } from '@app/Components/Filter/Filter';
import { Api } from '@app/Api';
import { setDefaultFilterProp } from '@app/Components/ProjectsOverview/helpers';
var LastVersionOnlyOptions = [
    { value: '1', label: 'YES' },
    { value: '2', label: 'NO' }
];
export var DocumentsDownloadFilter = /** @class */ (function (_super) {
    __extends(DocumentsDownloadFilter, _super);
    function DocumentsDownloadFilter() {
        var _this = this;
        var _a, _b, _c;
        _this = _super.apply(this, arguments) || this;
        _this._filterTimerId = null;
        _this._yearFilter = {
            name: 'Year',
            codeName: 'year',
            type: FieldType.SELECT,
            options: [],
            value: [],
            isMulti: true,
            onChange: function (value) {
                _this._yearFilter.value = value ? value : [];
                _this._onFilterChange();
            }
        };
        _this._projectNameFilter = {
            name: 'Project Name / Number',
            codeName: 'projectName',
            type: FieldType.TEXT,
            value: ((_a = _this.props.defaultFilters) === null || _a === void 0 ? void 0 : _a['projectName']) || '',
            onChange: function (value) {
                _this._projectNameFilter.value = value;
                _this._onFilterChange();
            }
        };
        _this._leaderFilter = {
            name: 'Leader',
            codeName: 'leader',
            type: FieldType.PERSON_PICKER,
            options: [],
            value: ((_b = _this.props.defaultFilters) === null || _b === void 0 ? void 0 : _b.leader) || [],
            isMulti: true,
            onChange: function (value) {
                _this._leaderFilter.value = value ? value : [];
                _this._onFilterChange();
            }
        };
        _this._leadResponsibleOrgUnitFilter = {
            name: 'Lead Responsible Org Unit',
            codeName: 'leadResponsibleOrgUnit',
            type: FieldType.SELECT,
            options: [],
            value: undefined,
            onChange: function (value) {
                _this._leadResponsibleOrgUnitFilter.value = value;
                _this._onFilterChange();
            }
        };
        _this._statusFilter = {
            name: 'Status',
            codeName: 'status',
            type: FieldType.SELECT,
            options: [],
            value: [],
            isMulti: true,
            onChange: function (value) {
                _this._statusFilter.value = value ? value : [];
                _this._onFilterChange();
            }
        };
        _this._categoryFilter = {
            name: 'Category',
            codeName: 'category',
            type: FieldType.SELECT,
            options: [],
            value: [],
            isMulti: true,
            onChange: function (value) {
                _this._categoryFilter.value = value ? value : [];
                _this._onFilterChange();
            }
        };
        _this._deliverableByCodeFilter = {
            name: 'Deliverable by Code',
            codeName: 'deliverableByCode',
            type: FieldType.SELECT,
            options: [],
            value: [],
            isMulti: true,
            onChange: function (value) {
                _this._deliverableByCodeFilter.value = value ? value : [];
                _this._onFilterChange();
            }
        };
        _this._lastVersionOnlyFilter = {
            name: 'Last Version Only',
            codeName: 'lastVersionOnly',
            type: FieldType.SELECT,
            options: LastVersionOnlyOptions,
            value: ((_c = _this.props.defaultFilters) === null || _c === void 0 ? void 0 : _c['lastVersionOnly']) || LastVersionOnlyOptions[0],
            onChange: function (value) {
                _this._lastVersionOnlyFilter.value = value;
                _this._onFilterChange();
            }
        };
        _this._filters = [
            _this._yearFilter,
            _this._projectNameFilter,
            _this._leaderFilter,
            _this._leadResponsibleOrgUnitFilter,
            _this._statusFilter,
            _this._categoryFilter,
            _this._deliverableByCodeFilter,
            _this._lastVersionOnlyFilter
        ];
        return _this;
    }
    Object.defineProperty(DocumentsDownloadFilter.prototype, "_filterOptions", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var years = (_a = this._yearFilter.value) === null || _a === void 0 ? void 0 : _a.map(function (it) { return +it.value; });
            var projectLeaderIds = (_b = this._leaderFilter.value) === null || _b === void 0 ? void 0 : _b.map(function (it) { return +it.value; });
            var orgUnitId = (_c = this._leadResponsibleOrgUnitFilter.value) === null || _c === void 0 ? void 0 : _c.value;
            var categories = (_d = this._categoryFilter.value) === null || _d === void 0 ? void 0 : _d.map(function (it) { return it.value; });
            var deliverableCodes = (_e = this._deliverableByCodeFilter.value) === null || _e === void 0 ? void 0 : _e.map(function (it) { return it.value; });
            return {
                years: (years === null || years === void 0 ? void 0 : years.length) ? years : undefined,
                projectDisplayNameAndNumber: this._projectNameFilter.value || undefined,
                projectLeaderIds: (projectLeaderIds === null || projectLeaderIds === void 0 ? void 0 : projectLeaderIds.length) ? projectLeaderIds : undefined,
                orgUnitId: orgUnitId ? +orgUnitId : undefined,
                statuses: (_f = this._statusFilter.value) === null || _f === void 0 ? void 0 : _f.map(function (it) { return it.label; }),
                categories: (categories === null || categories === void 0 ? void 0 : categories.length) ? categories : undefined,
                deliverableCodes: (deliverableCodes === null || deliverableCodes === void 0 ? void 0 : deliverableCodes.length) ? deliverableCodes : undefined,
                isLastDocumentVersionOnly: ((_g = this._lastVersionOnlyFilter.value) === null || _g === void 0 ? void 0 : _g.label) !== 'NO'
            };
        },
        enumerable: false,
        configurable: true
    });
    DocumentsDownloadFilter.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var yearsResponse, orgUnitsResponse, statusResponse, categoryResponse, deliverableCodesResponse;
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            Api.secured.getProjectYearLookups(),
                            Api.secured.getOrgUnitsLookupInfo({ isActiveOrWithProjectsOnly: true }),
                            Api.secured.getProjectStatusEnum(),
                            Api.secured.getProjectCategoryEnum(),
                            Api.secured.getProjectDeliverableCodeLookups()
                        ])];
                    case 1:
                        yearsResponse = (_a = _b.sent(), _a[0]), orgUnitsResponse = _a[1], statusResponse = _a[2], categoryResponse = _a[3], deliverableCodesResponse = _a[4];
                        runInAction(function () {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                            _this._yearFilter.options = yearsResponse.map(function (item) { return (__assign(__assign({}, item), { value: "".concat(item.value) })); });
                            if ((_b = (_a = _this.props.defaultFilters) === null || _a === void 0 ? void 0 : _a.year) === null || _b === void 0 ? void 0 : _b.length) {
                                setDefaultFilterProp(_this._yearFilter, (_c = _this.props.defaultFilters) === null || _c === void 0 ? void 0 : _c.year);
                            }
                            _this._leadResponsibleOrgUnitFilter.options = orgUnitsResponse.map(function (item) { return ({
                                value: "".concat(item.id),
                                label: item.codeName
                            }); });
                            if ((_d = _this.props.defaultFilters) === null || _d === void 0 ? void 0 : _d.leadResponsibleOrgUnit) {
                                if (_this._leadResponsibleOrgUnitFilter.options.some(function (option) { var _a, _b; return option.value === ((_b = (_a = _this.props.defaultFilters) === null || _a === void 0 ? void 0 : _a.leadResponsibleOrgUnit) === null || _b === void 0 ? void 0 : _b.value); })) {
                                    _this._leadResponsibleOrgUnitFilter.value = (_e = _this.props.defaultFilters) === null || _e === void 0 ? void 0 : _e.leadResponsibleOrgUnit;
                                }
                            }
                            _this._statusFilter.options = statusResponse;
                            if ((_g = (_f = _this.props.defaultFilters) === null || _f === void 0 ? void 0 : _f.status) === null || _g === void 0 ? void 0 : _g.length) {
                                setDefaultFilterProp(_this._statusFilter, (_h = _this.props.defaultFilters) === null || _h === void 0 ? void 0 : _h.status);
                            }
                            _this._categoryFilter.options = categoryResponse;
                            if ((_k = (_j = _this.props.defaultFilters) === null || _j === void 0 ? void 0 : _j.category) === null || _k === void 0 ? void 0 : _k.length) {
                                setDefaultFilterProp(_this._categoryFilter, (_l = _this.props.defaultFilters) === null || _l === void 0 ? void 0 : _l.category);
                            }
                            _this._deliverableByCodeFilter.options = deliverableCodesResponse.map(function (item) { return (__assign(__assign({}, item), { value: "".concat(item.value) })); });
                            if ((_o = (_m = _this.props.defaultFilters) === null || _m === void 0 ? void 0 : _m.deliverableByCode) === null || _o === void 0 ? void 0 : _o.length) {
                                setDefaultFilterProp(_this._deliverableByCodeFilter, (_p = _this.props.defaultFilters) === null || _p === void 0 ? void 0 : _p.deliverableByCode);
                            }
                        });
                        this.props.onFilterProjects(this._filterOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentsDownloadFilter.prototype.componentWillUnmount = function () {
        this._clearFilterTimeout();
    };
    DocumentsDownloadFilter.prototype._onFilterChange = function () {
        var _this = this;
        this._clearFilterTimeout();
        this._filterTimerId = window.setTimeout(function () {
            _this.props.onFilterProjects(_this._filterOptions);
        }, 500);
    };
    DocumentsDownloadFilter.prototype._clearFilters = function () {
        this._clearFilterTimeout();
        this._filters.map(function (f) {
            if (f.isMulti) {
                f.value = [];
            }
            else {
                var value = void 0;
                switch (f.type) {
                    case FieldType.SELECT: {
                        value = null;
                        break;
                    }
                    default: {
                        value = '';
                    }
                }
                f.value = value;
            }
        });
        // Showing the last version only is the default state of the page, not an applied filter.
        this._lastVersionOnlyFilter.value = LastVersionOnlyOptions[0];
        this.props.onFilterClear();
    };
    DocumentsDownloadFilter.prototype._onSaveFilters = function () {
        var _a, _b;
        var filtersParams = {
            year: this._yearFilter.value,
            projectName: this._projectNameFilter.value,
            leader: (_b = (_a = this._leaderFilter.value) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, function (leader) { return (__assign(__assign({}, leader), { label: leader.displayName })); }),
            leadResponsibleOrgUnit: this._leadResponsibleOrgUnitFilter.value,
            status: this._statusFilter.value,
            category: this._categoryFilter.value,
            deliverableByCode: this._deliverableByCodeFilter.value,
            lastVersionOnly: this._lastVersionOnlyFilter.value
        };
        this.props.onFiltersSave(filtersParams);
    };
    DocumentsDownloadFilter.prototype._resetFilters = function () {
        this.props.onFilterReset();
        this._clearFilters();
    };
    DocumentsDownloadFilter.prototype._clearFilterTimeout = function () {
        if (this._filterTimerId)
            window.clearTimeout(this._filterTimerId);
    };
    DocumentsDownloadFilter.prototype.render = function () {
        return (React.createElement(Filter, { filters: this._filters, onFiltersSave: this._onSaveFilters, onFiltersClear: this._clearFilters, onFiltersReset: this._resetFilters }));
    };
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_yearFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_projectNameFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_leaderFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_leadResponsibleOrgUnitFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_statusFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_categoryFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_deliverableByCodeFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_lastVersionOnlyFilter", void 0);
    __decorate([
        observable
    ], DocumentsDownloadFilter.prototype, "_filters", void 0);
    __decorate([
        computed
    ], DocumentsDownloadFilter.prototype, "_filterOptions", null);
    __decorate([
        action.bound
    ], DocumentsDownloadFilter.prototype, "_onFilterChange", null);
    __decorate([
        action.bound
    ], DocumentsDownloadFilter.prototype, "_clearFilters", null);
    __decorate([
        action.bound
    ], DocumentsDownloadFilter.prototype, "_onSaveFilters", null);
    __decorate([
        action.bound
    ], DocumentsDownloadFilter.prototype, "_resetFilters", null);
    DocumentsDownloadFilter = __decorate([
        observer
    ], DocumentsDownloadFilter);
    return DocumentsDownloadFilter;
}(React.PureComponent));
